import { type UseMutationOptions, useMutation } from '@tanstack/react-query';
import { ItemsApi } from '@/common/api/items';
import type { Item, ItemPatchRequest } from '@/common/api/types/items';

type UpdateItemVariables = { itemId: number; data: ItemPatchRequest };

type UpdateItemMutationOptions = Omit<
  UseMutationOptions<Item, Error, UpdateItemVariables>,
  'mutationFn'
>;

export const useUpdateItemMutation = (options?: UpdateItemMutationOptions) => {
  return useMutation({
    ...options,
    mutationFn: ({ itemId, data }: UpdateItemVariables) =>
      ItemsApi.updateItem({
        itemId,
        data,
      }),
  });
};
